import React from "react";
import {
  CustomButton2,
  CustomInput,
  CustomModal,
  CustomView,
} from "../../../../components";
import Context from "../../../../context";
import { ICreateAndUpdateDriver } from "../../../../types/driver.interface";

import "./index.sass";
import { useFormik } from "formik";
import { ICreateAndUpdateClient } from "../../../../types/client.interface";
import * as Yup from "yup";
import validations from "../../../../validations";

const Update = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, selectedClient, updateClient, loading } =
    React.useContext(Context.ClientScreen);

  const formik = useFormik<ICreateAndUpdateClient>({
    enableReinitialize: true,
    initialValues: {
      phoneNumber: selectedClient?.phoneNumber,
      firstName: selectedClient?.firstName,
      lastName: selectedClient?.lastName,
    },
    validationSchema: Yup.object({
      lastName: validations.yupValidations.lastName,
      firstName: validations.yupValidations.firstName,
      phoneNumber: validations.yupValidations.phoneNumber,
    }),
    onSubmit: (values: ICreateAndUpdateClient, { setSubmitting }) => {
      const formValues: ICreateAndUpdateClient = {
        _id: selectedClient?._id,
        ...values,
      };
      updateClient!(formValues);
    },
  });

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="client-update-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "UPDATE"}
        maxWidth={"40rem"}
      >
        <form onSubmit={formik?.submitForm}>
          <CustomView.Row className="form-row">
            <CustomView.Column medium={6} className="form-colum">
              <CustomInput
                name="firstName"
                id="firstName"
                label="نام"
                value={formik.values.firstName}
                onValueChange={formik.handleChange}
                formikProps={{ onBlur: formik.handleBlur }}
                error={formik.errors.firstName && formik.touched.firstName}
                errorText={formik.errors.firstName}
              />
            </CustomView.Column>
            <CustomView.Column medium={6} className="form-colum">
              <CustomInput
                name="lastName"
                id="lastName"
                label="نام خانوادگی"
                value={formik.values.lastName}
                onValueChange={formik.handleChange}
                formikProps={{ onBlur: formik.handleBlur }}
                error={formik.errors.lastName && formik.touched.lastName}
                errorText={formik.errors.lastName}
              />
            </CustomView.Column>
            <CustomView.Column medium={6} className="form-colum">
              <CustomInput
                name="phoneNumber"
                id="phoneNumber"
                label="شماره موبایل"
                value={formik.values.phoneNumber}
                onValueChange={formik.handleChange}
                formikProps={{ onBlur: formik.handleBlur }}
                error={formik.errors.phoneNumber && formik.touched.phoneNumber}
                errorText={formik.errors.phoneNumber}
              />
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column>
              <CustomButton2
                title={"ثبت"}
                type="primary"
                onClick={formik?.submitForm}
                isLoading={loading}
              />
            </CustomView.Column>
          </CustomView.Row>
        </form>
      </CustomModal>
    </section>
  );
};

export default Update;
